import { createAction, props } from '@ngrx/store';
import { AzzurroHubDataType } from 'ngx-core-services';

export const updateAzzurroHubData = createAction(
  '[System - AzzurroHub] Update AzzurroHub Data',
  props<{ systemId: string; changes: Partial<AzzurroHubDataType> }>()
);
